var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragHolderIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0032c5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.391)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 22) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 0.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 18.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 9.391)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 22) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 0.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 18.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 9.391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHolderIcon);
export default __webpack_public_path__ + "static/media/drag-holder-icon.6ee6a32ec6012636e2f6493bed0d8b55.svg";
export { ForwardRef as ReactComponent };